import React, { useState, useEffect } from "react";
import * as api from "../api/api";
import LobInfo from "../Components/LobInfo";
import startAdding from "../../src/images/startAdding.svg";
import Loading from "../Components/Loading";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { Snackbar, Alert } from "@mui/material";
import strings from "../Components/Localization/strings";
import { useLanguage } from "../Components/Localization/LanguageContext";

function AdminLob(props) {
  const [lobList, setLobList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [snackbarData, setSnackbarData] = useState({});
  const { language } = useLanguage();
  const pageTitle = "AdminLob";
  const [isAdding, setIsAdding] = useState(false);

  const navigate = useNavigate();

  const getAllLobs = () => {
    setIsAdding(false);
    console.log("fetching Lobs");
    setLoading(true);
    api
      .getAllLobs()
      .then((response) => {
        console.log(response.data.object);
        setLobList(response.data.object);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error in fetching lobs", error);
      });
  };

  useEffect(() => {
    checkAuthorization("LINE_OF_BUSINESS").then((result) => {
      if (result) {
        getAllLobs();
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);
  const handleAddLob = () => {
    setIsAdding(true);
    const newLob = { id: "", name: "" };
    setLobList([...lobList, newLob]);
  };
  const handleRemoveLob = (removeID) => {
    setLobList(lobList.filter((lob) => (lob.id != removeID ? lob : "")));
  };
  return (
    <div className="main-content">
      {isLoading ? <Loading /> : ""}
      <p className="main-content__title">
        {strings[pageTitle][language].pageName}
      </p>
      <hr className="main-content-title__hr" />
      <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarData.show}
        autoHideDuration={3000}
        onClose={() => setSnackbarData({ ...snackbarData, show: false })}
      >
        <Alert severity={snackbarData.severity} sx={{ width: "100%" }}>
          {snackbarData.message}
        </Alert>
      </Snackbar>

      {lobList.length > 0 && !isLoading ? (
        <div className="team-list">
          {lobList.map((lob) => (
            <LobInfo
              lob={lob}
              handleRemoveLob={handleRemoveLob}
              allLobs={lobList}
              manipulateSnackbar={setSnackbarData}
              snackbarData={snackbarData}
              refreshLobs={getAllLobs}
              setIsAdding={setIsAdding}
            />
          ))}
        </div>
      ) : (
        <div className="d-flex gap-3 flex-column justify-content-center align-items-center">
          <img src={startAdding} alt="start adding" />
          <h5 className="mt-auto p-2 bd-highlight">
            {strings[pageTitle][language].empty}
          </h5>
        </div>
      )}

      <div style={{ borderBottom: "1px solid black", margin: "1em" }}></div>
      <button
        className="button-round"
        style={{ alignSelf: "flex-end", margin: "1em" }}
        onClick={handleAddLob}
        disabled={isAdding}
      >
        {strings[pageTitle][language].add}
      </button>
    </div>
  );
}

export default AdminLob;
